import { render, staticRenderFns } from "./BankIntegrationView.vue?vue&type=template&id=a4f47d0e"
import script from "./BankIntegrationView.vue?vue&type=script&lang=js"
export * from "./BankIntegrationView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports